// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Skeleton, Table } from '@/ui';
import { Pagination } from '@/components';
import { StyledWrapper } from './RegionSettlementsListStyles';

// Models
import { IRegionSettlement } from '@/models/regions.model';

// Helpers
import { getRegionSettlementsTableColumns } from './columns';

type TRegionSettlementsList = {
  regionsSettlements: IRegionSettlement[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  canManage: boolean;
  onStatusChange: (id: string) => void;
  onInHeaderToggle: (id: string) => void;
  onPageChange: (page: number) => void;
};

const RegionSettlementsList = ({
  isLoading,
  regionsSettlements,
  total,
  currentPage,
  canManage,
  onPageChange,
  onStatusChange,
  onInHeaderToggle,
}: TRegionSettlementsList) => {
  const { t } = useTranslation(['regions']);

  if (isLoading) return <Skeleton />;

  return (
    <StyledWrapper>
      <Table
        columns={getRegionSettlementsTableColumns({ t, onStatusChange, onInHeaderToggle, canManage })}
        dataSource={regionsSettlements}
      />
      <Pagination current={currentPage} total={total} onChange={onPageChange} />
    </StyledWrapper>
  );
};

export default RegionSettlementsList;
